import type {
  PartnerReferralGetApiData,
  PartnerReferralGetApiResponses,
  PartnerReferralListApiData,
  PartnerReferralListApiResponses,
  PartnerReferralOverviewApiData,
  PartnerReferralOverviewApiResponses,
  PartnerUserGroupReferralCreateApiData,
  PartnerUserGroupReferralCreateApiResponses,
  PartnerUserGroupReferralsListApiData,
  PartnerUserGroupReferralsListApiResponses,
  ReferralProgramActivityListApiData,
  ReferralProgramActivityListApiResponses,
  ReferralProgramGetApiData,
  ReferralProgramGetApiResponses,
  ReferralProgramListApiData,
  ReferralProgramListApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getPartnerReferralUrls = {
  getPaginatedPartnerReferrals: dataEndpoint<PartnerReferralListApiData, PartnerReferralListApiResponses>({
    getUrl: ({ serviceOrganizationId, ...queryParams }) =>
      apiUrl(`service-organizations/${serviceOrganizationId}/referrals/`, queryParams)
  }),
  getPartnerReferralOverview: dataEndpoint<PartnerReferralOverviewApiData, PartnerReferralOverviewApiResponses>({
    getUrl: ({ serviceOrganizationId }) => apiUrl(`service-organizations/${serviceOrganizationId}/referrals/overview/`)
  }),
  getPartnerReferral: dataEndpoint<PartnerReferralGetApiData, PartnerReferralGetApiResponses>({
    getUrl: ({ serviceOrganizationId, referralId }) =>
      apiUrl(`service-organizations/${serviceOrganizationId}/referrals/${referralId}/`)
  }),
  getPartnerUserGroupReferrals: dataEndpoint<
    PartnerUserGroupReferralsListApiData,
    PartnerUserGroupReferralsListApiResponses
  >({
    getUrl: ({ serviceOrganizationId, userGroupId }) =>
      apiUrl(`service-organizations/${serviceOrganizationId}/user-groups/${userGroupId}/referrals/`)
  }),
  postPartnerUserGroupReferral: responseEndpoint<
    PartnerUserGroupReferralCreateApiData,
    PartnerUserGroupReferralCreateApiResponses
  >({
    getUrl: ({ serviceOrganizationId, userGroupId }) =>
      apiUrl(`service-organizations/${serviceOrganizationId}/user-groups/${userGroupId}/referrals/`)
  }),
  getPartnerReferralPrograms: dataEndpoint<ReferralProgramListApiData, ReferralProgramListApiResponses>({
    getUrl: ({ serviceOrganizationId }) => apiUrl(`service-organizations/${serviceOrganizationId}/referral-programs/`)
  }),
  getPartnerReferralProgram: dataEndpoint<ReferralProgramGetApiData, ReferralProgramGetApiResponses>({
    getUrl: ({ serviceOrganizationId, brandId }) =>
      apiUrl(`service-organizations/${serviceOrganizationId}/referral-programs/${brandId}/`)
  }),
  getPaginatedPartnerReferralProgramActivities: dataEndpoint<
    ReferralProgramActivityListApiData,
    ReferralProgramActivityListApiResponses
  >({
    getUrl: ({ serviceOrganizationId, brandId, ...queryParams }) =>
      apiUrl(`service-organizations/${serviceOrganizationId}/referral-programs/${brandId}/activities/`, queryParams)
  })
};
